import { render, staticRenderFns } from "./SaveVariableDropdown.vue?vue&type=template&id=480bee71&"
import script from "./SaveVariableDropdown.vue?vue&type=script&lang=ts&"
export * from "./SaveVariableDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SaveVariableDropdown.vue?vue&type=style&index=0&id=480bee71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports